import { toast } from "sonner";
import { CheckCircle, XCircle, Info, AlertTriangle } from "lucide-react";

const toastTheme = {
	success: {
		accent: "#16a34a",
		background: "#f0fdf4",
		color: "#14532d",
		iconBackground: "#dcfce7",
	},
	error: {
		accent: "#dc2626",
		background: "#fff5f5",
		color: "#7f1d1d",
		iconBackground: "#fee2e2",
	},
	info: {
		accent: "#2563eb",
		background: "#eff6ff",
		color: "#1e3a8a",
		iconBackground: "#dbeafe",
	},
	warning: {
		accent: "#d97706",
		background: "#fffbeb",
		color: "#78350f",
		iconBackground: "#fef3c7",
	},
};

const useToastNotification = () => {
	const showToast = (
		message: string,
		type: "success" | "error" | "info" | "warning",
	) => {
		const theme = toastTheme[type];

		const getIcon = () => {
			const iconClassName = "h-5 w-5";

			switch (type) {
				case "success":
					return <CheckCircle className={iconClassName} />;
				case "error":
					return <XCircle className={iconClassName} />;
				case "info":
					return <Info className={iconClassName} />;
				case "warning":
					return <AlertTriangle className={iconClassName} />;
				default:
					return null;
			}
		};

		toast(message, {
			duration: type === "error" ? 5000 : 3500,
			icon: (
				<span
					className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full"
					style={{
						backgroundColor: theme.iconBackground,
						color: theme.accent,
					}}>
					{getIcon()}
				</span>
			),
			style: {
				alignItems: "flex-start",
				backgroundColor: theme.background,
				border: `1px solid ${theme.accent}30`,
				borderLeft: `5px solid ${theme.accent}`,
				borderRadius: "16px",
				boxShadow: "0 18px 45px rgba(15, 23, 42, 0.14)",
				color: theme.color,
				fontFamily: "Poppins, sans-serif",
				fontSize: "14px",
				fontWeight: 500,
				gap: "12px",
				lineHeight: "1.45",
				maxWidth: "420px",
				padding: "14px 16px",
			},
		});
	};

	return { showToast };
};

export default useToastNotification;
